import React from 'react';

import { IconProps } from './types';

export const HelpIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M12.5 2.25C7.125 2.25 2.75 6.625 2.75 12C2.75 17.375 7.125 21.75 12.5 21.75C17.875 21.75 22.25 17.375 22.25 12C22.25 6.625 17.875 2.25 12.5 2.25ZM12.5 3.75C17.0645 3.75 20.75 7.43555 20.75 12C20.75 16.5645 17.0645 20.25 12.5 20.25C7.93555 20.25 4.25 16.5645 4.25 12C4.25 7.43555 7.93555 3.75 12.5 3.75ZM12.959 6.75195C12.7754 6.74805 12.5957 6.76172 12.4199 6.79492C11.373 6.98438 10.5156 7.79883 10.3027 8.84961C10.2383 9.11719 10.3262 9.39648 10.5293 9.58008C10.7324 9.76367 11.0195 9.82227 11.2773 9.73242C11.5371 9.64258 11.7266 9.41992 11.7715 9.15039C11.8926 8.55273 12.457 8.11523 13.166 8.28516C13.6953 8.41211 13.998 8.83789 13.998 9.43359C13.998 10.1406 13.6816 10.5039 13.1582 11.1074C12.6328 11.7109 11.916 12.5156 11.7559 13.7812C11.7031 14.1914 11.9941 14.5684 12.4062 14.6191C12.8164 14.6719 13.1914 14.3809 13.2441 13.9707C13.3477 13.1582 13.7559 12.707 14.291 12.0918C14.8242 11.4746 15.498 10.6562 15.498 9.43359C15.498 8.23828 14.7266 7.11914 13.5176 6.82812C13.3301 6.7832 13.1426 6.75781 12.959 6.75195ZM12.5 15.75C12.0859 15.75 11.75 16.0859 11.75 16.5C11.75 16.9141 12.0859 17.25 12.5 17.25C12.9141 17.25 13.25 16.9141 13.25 16.5C13.25 16.0859 12.9141 15.75 12.5 15.75Z"
          fill={color}
        />
      </svg>
    );
  },
);
